import React, { useCallback, useState } from 'react'
import { IoIosInformationCircle } from 'react-icons/io'

import PropTypes from 'prop-types'

import Tooltip from '~/components/Tooltip'

import * as S from './styles'

const ToogleInput = ({
  label,
  description,
  name,
  onChange,
  size = 'medium',
  isChecked = false,
  isAsync = false,
  className = '',
  textLeft,
  textTooltip = '',
  ...rest
}) => {
  const [checked, setChecked] = useState(!!isChecked)
  const [loading, setLoading] = useState(false)

  const handleLoading = useCallback(value => {
    setLoading(false)
    setChecked(value)
  }, [])

  const handleChange = useCallback(
    e => {
      if (!isAsync) {
        setChecked(e.target.checked)
      } else {
        setLoading(true)
      }

      onChange?.({ e, handleLoading })
    },
    [handleLoading, isAsync, onChange]
  )

  return (
    <S.Container
      className={className}
      isLoading={loading}
      size={size}
      textLeft={textLeft}
    >
      {textLeft && (
        <input
          id={name}
          name={name}
          type="checkbox"
          className="toggle"
          checked={checked}
          onChange={handleChange}
          {...rest}
        />
      )}

      {label && (
        <S.Content>
          <S.ContentLabel>
            <S.Label htmlFor={name}>{label}</S.Label>
            {textTooltip && (
              <Tooltip
                noMargin
                icon={<IoIosInformationCircle />}
                text={textTooltip}
              />
            )}
          </S.ContentLabel>
          {description && <S.Description>{description}</S.Description>}
        </S.Content>
      )}

      {!textLeft && (
        <input
          id={name}
          name={name}
          type="checkbox"
          className="toggle"
          checked={checked}
          onChange={handleChange}
          {...rest}
        />
      )}
    </S.Container>
  )
}

ToogleInput.defaultProps = {
  label: null,
  description: null,
  onChange: null,
  isChecked: false,
  isAsync: false,
  className: null,
  textLeft: false,
  size: 'medium',
  textTooltip: ''
}

ToogleInput.propTypes = {
  label: PropTypes.string,
  description: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  isChecked: PropTypes.bool,
  isAsync: PropTypes.bool,
  className: PropTypes.string,
  textLeft: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium']),
  textTooltip: PropTypes.string
}

export default ToogleInput
